<template lang="html">
  <div class="tracking">
    <h1>Tracking-Online®</h1>
    <b-row>
      <b-col md="2"></b-col>
      <b-col md="8">
        <div class="shadowed-card">
          <h3>Il servizio Tracking-Online® comprende le seguenti funzionalità:</h3>
          <p><font-awesome-icon icon="check"></font-awesome-icon>{{ $ml.get('tracking.list_item_1') }}</p>
          <p><font-awesome-icon icon="check"></font-awesome-icon>{{ $ml.get('tracking.list_item_2') }}</p>
          <p><font-awesome-icon icon="check"></font-awesome-icon>{{ $ml.get('tracking.list_item_3') }}</p>
          <p><font-awesome-icon icon="check"></font-awesome-icon>{{ $ml.get('tracking.list_item_4') }}</p>
          <p><font-awesome-icon icon="check"></font-awesome-icon>{{ $ml.get('tracking.list_item_5') }}</p>
          <p><font-awesome-icon icon="check"></font-awesome-icon>{{ $ml.get('tracking.list_item_6') }}</p>
          <p><font-awesome-icon icon="check"></font-awesome-icon>{{ $ml.get('tracking.list_item_7') }}</p>
          <p><font-awesome-icon icon="check"></font-awesome-icon>{{ $ml.get('tracking.list_item_8') }}</p>
          <p><font-awesome-icon icon="check"></font-awesome-icon>{{ $ml.get('tracking.list_item_9') }}</p>
          <p><font-awesome-icon icon="check"></font-awesome-icon>{{ $ml.get('tracking.list_item_10') }}</p>
          <p><font-awesome-icon icon="check"></font-awesome-icon>{{ $ml.get('tracking.list_item_11') }}</p>
          <b-button variant="success"
            class="mt-4 mb-4"
            href="/contacts">{{ $ml.get('tracking.submit') }}</b-button>
        </div>
      </b-col>
      <b-col md="2"></b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  data () {
    return null
  }
}
</script>

<style lang="css" scoped>
.shadowed-card {
  /*background-color: rgba(61, 138, 255, 0.32);*/
  margin-top: 2rem;
  box-shadow: 10px 10px 10px #dedede;
  padding: 0.9rem;
}

.shadowed-card h3 {
  margin-bottom: 0.6rem;
  padding: 5px;
  border-bottom: 1px solid rgba(61, 138, 255, 0.32);
}

.shadowed-card p {
  text-align: left
}

.shadowed-card p svg {
  margin-right: 5px;
  color: #00891A;
}

.copy {
  font-family: Arial, Helvetica, sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/components/Tracking.vue